module.exports = __webpack_public_path__ + "media/Goals/EatSustainably-f9036e4e.svg";